import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import DataTable from "../../Components/ui/dataTable";
import { Button } from "../../Components/ui/button";
import { SkeletonTable } from "../../Components/ui/skeleton";
import Pagination from "../../Components/ui/pagination";
import { parseMoney } from "../../Lib/utils";
import { useGetVendorItemsQuery } from "./VendorApi";

const VendorItems = ({ vendorId }) => {
  const [page, setPage] = useState(1);
  const { data, isLoading: loading } = useGetVendorItemsQuery(
    { vendorId, page },
    {
      refetchOnFocus: true,
      refetchOnReconnect: true,
      refetchOnMountOrArgChange: true,
    },
  );

  const columns = [
    {
      accessorKey: "imageFilePath",
      header: "Picture",
      cell: ({ row }) =>
        row.original?.imageFilePath ? (
          <img
            src={`${process.env.REACT_APP_BASE_URL}file/asset/${row.original.imageFilePath}`}
            alt={row.original?.name || row.original?.title || "Item"}
            className='h-10 w-10 rounded-md object-cover border border-gray-100'
          />
        ) : (
          <div className='h-10 w-10 rounded-md bg-gray-100' />
        ),
    },
    {
      accessorKey: "name",
      header: "Item Name",
      cell: ({ row }) => (
        <div className='font-semibold whitespace-nowrap'>
          {row.original?.name || row.original?.title || "N/A"}
        </div>
      ),
    },
    {
      accessorKey: "category",
      header: "Category",
      cell: ({ row }) => <div>{row.original?.category || "N/A"}</div>,
    },
    {
      accessorKey: "amount",
      header: "Price",
      cell: ({ row }) => (
        <div>
          {row.original?.amount !== undefined
            ? parseMoney(row.original.amount)
            : "N/A"}
        </div>
      ),
    },
    {
      accessorKey: "availability",
      header: "Availability",
      cell: ({ row }) => {
        const available = Boolean(row.original?.availability);
        return (
          <Button
            asChild
            variant={available ? "successful" : "failed"}
            size='sm'
          >
            <p>{available ? "Available" : "Unavailable"}</p>
          </Button>
        );
      },
    },
    {
      accessorKey: "createdAt",
      header: "Date Added",
      cell: ({ row }) => (
        <div>
          {row.original?.createdAt
            ? format(parseISO(row.original.createdAt), "LLL dd, y")
            : "N/A"}
        </div>
      ),
    },
  ];

  return (
    <div className='w-full'>
      <div className='table-scroll max-h-[50vh] overflow-auto max-w-full rounded-md border'>
        <div className='w-full'>
          {loading ? (
            <SkeletonTable />
          ) : (
            <DataTable columns={columns} data={data?.data?.data} />
          )}
        </div>
      </div>
      {!loading && (
        <Pagination
          page={page}
          limit={data?.data?.limit ?? 0}
          total={data?.data?.total ?? 0}
          setPage={setPage}
        />
      )}
    </div>
  );
};

export default VendorItems;
